export const HOME_ROUTE = "/";
export const SKILLS_ROUTE = "/skills";
export const WORKS_ROUTE = "/works";
export const CONTACTS_ROUTE = "/contacts";
